export default {

    pass:
    {
       
            password:"ססמא ישנה",
            newPassword:"ססמא חדשה",
            newPasswordAgain:"ססמא חדשה שנית",
            changepass:'החלפת ססמא',
        
    },
    
    pos: {
        search: 'חיפוש',
        configuration: 'הגדרות',
        changepass: 'החלפת ססמא',
        language: 'שפה',
        theme: {
            name: 'מעטפת',
            light: 'בהיר',
            dark: 'כהה',
        },
         dashboard: {
            monthly_revenue: 'Monthly Revenue',
            new_orders: 'New Orders',
            pending_reviews: 'Pending Reviews',
            new_customers: 'New Customers',
            pending_orders: 'Pending Orders',
            order: {
                items: 'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
            },
            welcome: {
                title: 'Welcome to admin-on-rest demo',
                subtitle: 'This is the admin of an imaginary poster shop. Fell free to explore and modify the data - it\'s local to your computer, and will reset each time you reload.',
                aor_button: 'Admin-on-rest website',
                demo_button: 'Source for this demo',
            },
        },
    },
    resources: {
transactions: {
            name: 'טרנזאקציות |||| טרנזאקציות',
            fields: {
                products: 'Products',
            },

        },
plans: {
            name: 'תוכניות חיוב |||| תוכניות חיוב',
            fields: {
                products: 'Products',
            },

        },


banks: {
            name: 'בנקים |||| בנקים',
            fields: {
                products: 'Products',
            },

        },
agents: {
            name: 'סוכני מכירות |||| סוכני מכירות',
            fields: {
                products: 'Products',
            },

        },
        tagmul: {
            name: 'תוכניות תגמול |||| תוכניות תגמול',
            fields: {
                products: 'Products',
            },

        },
        frauds: {
            name: 'הונאה |||| הונאה',
            fields: {
                products: 'Products',
            },
        
        },
        'frauds/alerts': {
            name: 'הונאה - התראות |||| הונאה - התראות',
            fields: {
                products: 'Products',
            },
        
        },
        chb: {
            name: 'CHB |||| CHB',
            fields: {
                products: 'Products',
            },
        
        },
        'chb/alerts': {
            name: 'CHB - התראות |||| CHB - התראות',
            fields: {
                products: 'Products',
            },
        
        },
        bitulim: {
            name: 'ביטולים חדש |||| ביטולים חדש',
            fields: {
                products: 'Products',
            },
        
        },
        
        'Risks/duplicateOneMonth':{
            name: 'ניהול סיכונים - כרטיסים כפולים -חודשי |||| ניהול סיכונים - כרטיסים כפולים -חודשי ',
            fields: {
                products: 'Products',
            },
        },
        'Risks/duplicateHiyuvim':{
            name: 'ניהול סיכונים - חיובים כפולים בכרטיס |||| ניהול סיכונים - חיובים כפולים בכרטיס ',
            fields: {
                products: 'Products',
            },
        },
        'Risks/negativeTurnover':{
            name: 'ניהול סיכונים - ביטולים יחסית למחזור |||| ניהול סיכונים - ביטולים יחסית למחזור',
            fields: {
                products: 'Products',
            },
        },
        
        'Risks/ZicuNoMakor':{
            name: 'ניהול סיכונים - זיכויים ללא עסקת מקור |||| ניהול סיכונים - זיכויים ללא עסקת מקור',
            fields: {
                products: 'Products',
            },
        },
        
        'Risks/duplicateCard':{
            name: 'ניהול סיכונים - כרטיסים כפולים  |||| ניהול סיכונים - כרטיסים כפולים ',
            fields: {
                products: 'Products',
            },
        },
        'Risks/risks':{
            name: 'ניהול סיכונים  |||| ניהול סיכונים ',
            fields: {
                products: 'Products',
            },
        },
terminaltypes: {
            name: 'סוגי מסופים |||| סוגי מסופים',
            fields: {
                products: 'Products',
            },

        },
providernumbers: {
            name: 'מספרי ספק |||| מספרי ספק',
            fields: {
                products: 'Products',
            },

        },
        
    customers: {
            name: 'בתי עסק |||| בתי עסק',
            fields: {
                products: 'Products',
            },

        },    
zicuidateplans: {
            name: 'מועדי זיכוי |||| מועדי זיכוי',
            fields: {
                products: 'Products',
            },

        },
hafkadot: {
            name: 'הפקדות |||| הפקדות',
            fields: {
                products: 'Products',
            },

        },
zikuyim: {
            name: 'זיכויים |||| זיכויים',
            fields: {
                products: 'Products',
            },

        },        
hiyuvim: {
            name: 'חיובים |||| חיובים',
            fields: {
                products: 'Products',
            },

        },        
hafkadot_month: {
            name: 'הפקדות חודשי |||| הפקדות חודשי',
            fields: {
                products: 'Products',
            },

        },
hafkadot_ricuz_month: {
            name: 'הפקדות ריכוז חודשי |||| הפקדות ריכוז חודשי',
            fields: {
                products: 'Products',
            },

        },
hafkadot_ricuz_yomi: {
            name: 'הפקדות ריכוז יומי |||| הפקדות ריכוז יומי',
            fields: {
                products: 'Products',
            },

        },        
        commands: {
            name: 'Order |||| Orders',
            fields: {
                basket: {
                    delivery: 'Delivery',
                    reference: 'Reference',
                    quantity: 'Quantity',
                    sum: 'Sum',
                    tax_rate: 'Tax Rate',
                    total: 'Total',
                    unit_price: 'Unit Price',
                },
                date_gte: 'Passed Since',
                date_lte: 'Passed Before',
                total_gte: 'Min amount',
            },
        },
         
        products: {
            name: 'Poster |||| Posters',
            fields: {
                category_id: 'Category',
                height_gte: 'Min height',
                height_lte: 'Max height',
                height: 'Height',
                image: 'Image',
                price: 'Price',
                reference: 'Reference',
                stock_lte: 'Low Stock',
                stock: 'Stock',
                thumbnail: 'Thumbnail',
                width_gte: 'Min width',
                width_lte: 'mx_width',
                width: 'Width',
            },
            tabs: {
                image: 'Image',
                details: 'Details',
                description: 'Description',
                reviews: 'Reviews',
            },
        },
        categories: {
            name: 'Category |||| Categories',
            fields: {
                products: 'Products',
            },

        },
        reviews: {
            name: 'Review |||| Reviews',
            fields: {
                customer_id: 'Customer',
                command_id: 'Order',
                product_id: 'Product',
                date_gte: 'Posted since',
                date_lte: 'Posted before',
                date: 'Date',
                comment: 'Comment',
                rating: 'Rating',
            },
            action: {
                accept: 'Accept',
                reject: 'Reject',
            },
            notification: {
                approved_success: 'Review approved',
                approved_error: 'Error: Review not approved',
                rejected_success: 'Review rejected',
                rejected_error: 'Error: Review not rejected',
            },
        },
    },
};



// WEBPACK FOOTER //
// ./src/i18n/he.js